import { blocks } from '@yola/ws-sdk';
import { OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE } from '../../constants/display-options';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_HIDDEN_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import isOverlayTouchedVerifier from '../../verifiers/is-overlay-touched';
import copyDisplayOptionByAttribute from '../copy-display-option-by-attribute';
import getVisibleOptions from '../get-visible-options';

const getDisplayOptionsByBlockNode = (blockNode) =>
  blocks.accessors.getDisplayOptionsForElement(blockNode).filter((option) => !option.hidden);

const getDisplayOptionByAttribute = (displayOptions, attribute) =>
  displayOptions.find((option) => option.attribute === attribute) || null;

const isBackgroundApplied = (blockNode) =>
  blockNode.getAttribute(BACKGROUND_IMAGE_ATTRIBUTE) &&
  !blockNode.hasAttribute(BACKGROUND_HIDDEN_ATTRIBUTE) &&
  !blockNode.hasAttribute(BACKGROUND_PLACEHOLDER_ATTRIBUTE);

const handleChangeOverlay = ({ sourceBlockNode, displayOptions, destinationBlockNode }) => {
  if (!sourceBlockNode || !destinationBlockNode) {
    return;
  }

  const destinationBlockDisplayOptions = getDisplayOptionsByBlockNode(destinationBlockNode);
  const destinationOverlayOption = getDisplayOptionByAttribute(
    destinationBlockDisplayOptions,
    OVERLAY_ATTRIBUTE
  );

  if (!destinationOverlayOption) {
    return;
  }

  const visibleDisplayOptions = getVisibleOptions(displayOptions, sourceBlockNode);
  const overlayOption = getDisplayOptionByAttribute(visibleDisplayOptions, OVERLAY_ATTRIBUTE);

  if (overlayOption?.isEnabled) {
    copyDisplayOptionByAttribute({
      displayOptions,
      destinationBlockNode,
      attribute: OVERLAY_ATTRIBUTE,
    });
    copyDisplayOptionByAttribute({
      displayOptions,
      destinationBlockNode,
      attribute: OVERLAY_OPACITY_ATTRIBUTE,
    });

    return;
  }

  const isOverlayTouched = isOverlayTouchedVerifier(displayOptions);
  const isDestinationBlockWithBackground = isBackgroundApplied(destinationBlockNode);
  const isDestinationSameAsSource =
    blocks.accessors.getBlockIdByElement(destinationBlockNode) ===
    blocks.accessors.getBlockIdByElement(sourceBlockNode);

  if (isDestinationBlockWithBackground && !isOverlayTouched && !isDestinationSameAsSource) {
    destinationBlockNode.setAttribute(OVERLAY_ATTRIBUTE, '');
  }
};

export default handleChangeOverlay;
